import styled from '@emotion/styled';
import { nike } from '@nike/nike-design-tokens';

const {
  podiumCdsColorTextPrimaryInverse,
  podiumCdsColorGrey200,
  podiumCdsColorGrey300,
  podiumCdsColorBgPrimary
} = nike;

export const TableStyled = styled.div`
  border: 1px solid ${podiumCdsColorGrey300};
  background: ${podiumCdsColorBgPrimary};
  min-width: ${({ fullWidth, scrollbarSize }) =>
    `${fullWidth ? `calc(100% - ${scrollbarSize}px) !important` : 'auto'}`};
  width: 100%;
  display: inline-block;

  .th {
    padding: 10px;
    background: ${podiumCdsColorGrey200};
    border-bottom: 1px solid ${podiumCdsColorGrey300};
    font-weight: 600;
  }

  .tbody {
    overflow-y: overlay;
  }

  .td {
    padding: 20px 10px;
    display: flex;
    align-items: center;
    background: ${podiumCdsColorTextPrimaryInverse};
    border-bottom: 1px solid ${podiumCdsColorGrey300};
  }

  .tr {
    .td:last-child,
    .th:last-child {
      border-right: 0;
    }
  }
`;

export const StickyButton = styled.button`
  position: fixed;
  left: 96.5vw;
  bottom: 2vh;
  border-radius: 36px;
  padding: 9px 7px 6px;
  background-color: black;
`;
